module.exports = __webpack_public_path__ + "src/assets/games/23/190.jpg";